import { getDomainUserId } from '@/utils/getDomainUserId'
import type { InvestmentProject } from '@/types/InvestmentProject'

export const enqueueForTwilioContact = async (userPhone: string, listingId: string, locale: string) => {
  const { $config, $cdpDataService } = useNuxtApp()

  if ($config.public.twilioTriggerRecuperationFlow !== 'true') return

  const user = await $cdpDataService.getCustomerByPhone(userPhone)
  const triggerDate = getTriggerDate($config.public.environment)

  const { flowPhone, entryNameAlias } = getLocaleSpecificConfig(locale, $config)

  const listingIds = [listingId]

  if (user) {
    const { name, email, id } = user
    const leadName = name.includes('Usuario sin') ? '' : name

    const parameters = {
      listingIds,
      userId: id,
      leadName,
      leadEmail: email,
      leadCountryCode: locale.toUpperCase(),
      domainUserId: getDomainUserId(),
      entryNameAlias
    }

    await enqueueTwilioFlow($config, flowPhone, userPhone, triggerDate, parameters)
  }
}

const getLocaleSpecificConfig = (locale: string, config: any) => {
  const flowPhone = locale === 'mx' ? config.public.twilioOrchestratorFlowPhoneNumberMx : config.public.twilioOrchestratorFlowPhoneNumberCo
  const entryNameAlias = locale === 'mx' ? 'RECUPERATION_SAM_WEB_PDP_MX' : 'RECUPERATION_SAM_WEB_PDP_CO'
  return { flowPhone, entryNameAlias }
}

const enqueueTwilioFlow = async (config: any, flowPhone: string, userPhone: string, triggerDate: string, parameters: any) => {
  try {
    await $fetch('/api/buyer-front/twilio/enqueue-flow', {
      method: 'POST',
      body: {
        flowId: config.public.twilioOrchestratorFlowId,
        flowPhone,
        userPhone,
        triggerDate,
        parameters
      }
    })
  } catch (error) {
    useLogger().error({
      message: 'Error enqueuing for twilio contact'
    })
  }
}

export const calculateEnterpriseId = (listing: InvestmentProject): string => {
  const { $config } = useNuxtApp()
  const companyId = listing.raw_listing.companies[0].company_id
  const alliesServedBySammy = $config.public.alliesServedBySammy as string

  if (!alliesServedBySammy.trim()) {
    return ''
  }

  const alliesIds = alliesServedBySammy.split(',').map(id => id.trim()).filter(Boolean)

  if (alliesIds.length === 0 || !alliesIds.includes(companyId)) {
    return ''
  }

  return companyId
}

export const getTriggerDate = (environment: string) => {
  return environment === 'buyer-web-front-production' ? getTriggerDateForNextDay() : getTriggerDateForTests()
}

const getTriggerDateForTests = () => {
  const triggerDate = new Date()
  triggerDate.setMinutes(triggerDate.getMinutes() + 15)
  triggerDate.setSeconds(0)
  return triggerDate.toISOString().split('.')[0] + 'Z'
}

const getTriggerDateForNextDay = () => {
  const currentDateColombia = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }))
  currentDateColombia.setDate(currentDateColombia.getDate() + 1)
  const utcDate = new Date(Date.UTC(currentDateColombia.getFullYear(), currentDateColombia.getMonth(), currentDateColombia.getDate(), 14, currentDateColombia.getMinutes(), currentDateColombia.getSeconds()))
  return utcDate.toISOString().split('.')[0] + 'Z'
}
